import { Pool } from "../../../../utils/Pool";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Command } from "./Command";
export class DrawRenderElementCMD extends Command {
    static create(renderElement) {
        var cmd;
        cmd = DrawRenderElementCMD._pool.take();
        cmd.renderElement = renderElement;
        return cmd;
    }
    get renderElement() {
        return this._renderElement;
    }
    set renderElement(value) {
        this._renderElement = value;
        this._drawElementCMDData.setRenderelements([this._renderElement._renderElementOBJ]);
    }
    constructor() {
        super();
        this._drawElementCMDData = Laya3DRender.Render3DPassFactory.createDrawElementCMDData();
    }
    recover() {
        super.recover();
        DrawRenderElementCMD._pool.recover(this);
    }
    getRenderCMD() {
        return this._drawElementCMDData;
    }
    destroy() {
        this._renderElement = null;
        this._drawElementCMDData = null;
    }
}
DrawRenderElementCMD._pool = Pool.createPool(DrawRenderElementCMD);
